import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { EdgerRoll } from "../../models/EdgerRoll";
import { getEdgerRolls } from "../../repositories/EdgerRollRepository";
import { TableEdgerRoll } from "./components/TableEdgerRoll";

export const useEdgerRolls = (
	partId?: number,
	onError?: (error: Error) => void,
) => {
	return useQuery<EdgerRoll[], Error>({
		queryKey: ["edgerRolls", partId],
		queryFn: ({ signal }) => getEdgerRolls({ partId }, signal),
		onError: onError,
	});
};

export const EdgerRollPage = () => {
	const { partId } = useParams();

	return (
		<>
			<HelmetDexteel title="Edger Rolls" />
			<TableEdgerRoll partId={partId} />
		</>
	);
};
